export default "__VITE_ASSET__d7e4d8c0__"